import type { FC, ReactNode } from 'react'
import type { Hub } from '@/types'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

import { HubIcon } from '@/components/generals/hub-icon'

interface HubCardProps {
    hub: Hub
}

export const HubCard: FC<HubCardProps> = ({ hub }): ReactNode => {
    return (
        <Link
            href={`/${hub.slug}`}
            className='group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-colors hover:border-primary/50'
        >
            <div className='overflow-hidden bg-muted'>
                <img
                    src={hub.coverImage ?? '/images/hero-smile.jpg'}
                    alt=''
                    loading='lazy'
                    decoding='async'
                    className='aspect-[16/9] w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]'
                />
            </div>

            <div className='flex flex-1 flex-col p-6'>
                <div className='flex items-center gap-3'>
                    <span className='grid size-10 place-items-center rounded-lg bg-primary/10 text-primary'>
                        <HubIcon name={hub.icon} className='size-5' />
                    </span>

                    <h3 className='font-heading text-lg font-semibold tracking-tight text-foreground'>
                        {hub.name}
                    </h3>
                </div>

                <p className='mt-4 flex-1 text-sm leading-relaxed text-muted-foreground'>
                    {hub.tagline}
                </p>

                <div className='mt-6 flex items-center justify-between border-t border-border pt-4'>
                    <span className='text-xs font-medium uppercase tracking-wide text-muted-foreground'>
                        {hub.postCount ?? 0} {hub.postCount === 1 ? 'article' : 'articles'}
                    </span>

                    <span className='inline-flex items-center gap-1.5 text-sm font-semibold text-primary'>
                        Explore
                        <ArrowRight className='size-4 transition-transform group-hover:translate-x-1' />
                    </span>
                </div>
            </div>
        </Link>
    )
}
